import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';

import about01 from '../assets/about01.jpg';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';

import preview from '../assets/preview.png'
import upwork from '../assets/upwork-icon.svg'
import freelancer from '../assets/freelancer-icon.svg'
import github from '../assets/github.svg'
import SaurabhLogo from '../assets/SaurabhLogo.png'
import lion from '../assets/lion.png'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  email,
  mobile,
  api,
  about01,
  about02,
  about03,
  profile,
  circle,
  preview,
  upwork,
  github,
  freelancer,
  SaurabhLogo,
  lion,
};